/*!
 * KoliBri - The accessible HTML-Standard
 */
import { h, r as registerInstance, c as createEvent, H as Host } from './index-C_ZKddLG.js';
import { _ as __decorate } from './tslib.es6-QNbPBOk5.js';
import { B as BaseWebComponent } from './base-web-component-D909Fl-Y.js';
import { L as Log } from './common-D-vggmh2.js';
import './variant-quote-ClYWonZq.js';
import { c as createPropDefinition, n as normalizeString } from './normalizers-BNeak4hj.js';
import { b as bem } from './bem-registry-3ondDImf.js';
import { C as ClickButtonFC } from './component-WjvIfI-H.js';
import { d as delegateFocus, c as createCtaRef } from './element-interaction-C5-6aPzz.js';
import './_Uint8Array-kJHDjtoP.js';
import './isArray-CcrBs4JM.js';
import './element-focus-BQXzaLL9.js';

const nameProp = createPropDefinition('name', '', normalizeString);

const skeletonPropsConfig = {
    required: [nameProp],
};

const skeletonBem = bem.forBlock('kol-skeleton');
const BEM_CLASS_SKELETON__ACTIONS = skeletonBem('actions');
const BEM_CLASS_SKELETON__CONTAINER = skeletonBem('container');
const BEM_CLASS_SKELETON__COUNTER = skeletonBem('counter');
const BEM_CLASS_SKELETON__NAME = skeletonBem('name');
const SkeletonFC = (props) => {
    const { count, label, name, show, handleClick, refButton } = props;
    const hasName = !!(show && (name === null || name === void 0 ? void 0 : name.trim()));
    const BEM_CLASS_ROOT = skeletonBem({
        'has-name': hasName,
        'is-hidden': !show,
    });
    return (h("div", { class: BEM_CLASS_ROOT }, h("div", { class: BEM_CLASS_SKELETON__CONTAINER }, hasName && h("span", { class: BEM_CLASS_SKELETON__NAME }, name), h("div", { class: BEM_CLASS_SKELETON__COUNTER }, "Count: ", count)), h("div", { class: BEM_CLASS_SKELETON__ACTIONS }, h(ClickButtonFC, { label: label, handleClick: handleClick, refButton: refButton }))));
};

const KolSkeleton = class extends BaseWebComponent {
    constructor(hostRef) {
        super();
        registerInstance(this, hostRef);
        this.loaded = createEvent(this, "loaded");
        this.rendered = createEvent(this, "rendered");
        this.buttonRef = createCtaRef();
        this.count = 0;
        this.label = 'Label';
        this.show = true;
        this.handleClick = () => {
            var _a;
            Log.debug('Button clicked, count should be increased');
            this.setState('count', ((_a = this.getState('count')) !== null && _a !== void 0 ? _a : 0) + 1);
        };
    }
    async focus(options) { }
    async toggle() {
        var _a;
        this.setState('show', !((_a = this.getState('show')) !== null && _a !== void 0 ? _a : false));
        return Promise.resolve();
    }
    watchName(value) {
        nameProp.apply(value, (v) => this.setRenderProp('name', v));
    }
    handleKeyDown(event) {
        if (event.key === 'Enter' || event.key === ' ') {
            Log.debug('button pressed');
            this.handleClick();
        }
    }
    onKeydown(event) {
        if (event.key === 'Escape') {
            console.log('Show should be toggled');
            void this.toggle();
        }
    }
    componentWillLoad() {
        this.initRenderProps(skeletonPropsConfig);
        nameProp.apply(this._name, (v) => this.setRenderProp('name', v));
        this.intervalId = setInterval(() => {
            var _a;
            this.loaded.emit((_a = this.getState('count')) !== null && _a !== void 0 ? _a : 0);
        }, 2000);
    }
    componentDidLoad() {
        requestAnimationFrame(() => {
            this.rendered.emit();
        });
    }
    disconnectedCallback() {
        if (this.intervalId) {
            clearInterval(this.intervalId);
            this.intervalId = undefined;
        }
    }
    render() {
        return (h(Host, { key: '4c0c92a442827c3def7541b7f043e7e9b11fc5d4' }, h(SkeletonFC, { key: 'a1ef9d8d74c6a2008cb39c3efea5ec03286f82fc', count: this.count, label: this.label, name: this.getRenderProp('name'), handleClick: this.handleClick, onLoaded: this.loaded, onRendered: this.rendered, show: this.show, refButton: this.buttonRef })));
    }
    static get watchers() { return {
        "_name": ["watchName"]
    }; }
};
__decorate([
    delegateFocus('buttonRef')
], KolSkeleton.prototype, "focus", null);

export { KolSkeleton as kol_skeleton };
//# sourceMappingURL=kol-skeleton.entry.js.map
